import { useQuery } from 'react-query';
import { getTherapies } from 'App/services/AdminService';

function useFetchAdminTherapyCategoriesQuery() {
    return useQuery(['admin', 'categories'], getTherapies, {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
        cacheTime: 15 * 60 * 1000,
    });
}

export default useFetchAdminTherapyCategoriesQuery;
